import store from '../store'
const modulesFiles = require.context('../store/modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  modules.push(moduleName)
  return modules
}, [])
/**
 * 转数字
 */
export function turnNum(val) {
  return val ? 1 : 0
}
/**
 * 转布尔值
 */
export function turnBle(val) {
  return Number(val) ? !0 : !1
}

/**
 *
 * @param name 要清除store模块的名称
 */
export function resetVuex(name) {
  let moduleName = name || modules
  moduleName.map((item) => store.commit(`${item}/resetState`))
}

export function matchDataAssign(val, data) {
  for (let i in data) {
    for (let y in val) {
      if (y == i) val[y] = data[i]
    }
  }
  return val
}

export function getfilesize(size) {
  if (!size) return ''
  var num = 1024.0 //byte
  if (size < num) return size + 'B'
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + 'K' //kb
  if (size < Math.pow(num, 3)) return (size / Math.pow(num, 2)).toFixed(2) + 'M' //M
  if (size < Math.pow(num, 4)) return (size / Math.pow(num, 3)).toFixed(2) + 'G' //G
  return (size / Math.pow(num, 4)).toFixed(2) + 'T' //T
}

// 截取视频第一帧 url传base64位
export function getVideoBase64(url) {
  return new Promise(function (resolve, reject) {
    let dataURL = ''
    let video = document.createElement('video')
    video.setAttribute('src', url)
    video.setAttribute('width', 400)
    video.setAttribute('height', 240)
    video.setAttribute('preload', 'auto')
    video.addEventListener('loadeddata', function () {
      let canvas = document.createElement('canvas'),
        width = video.width, //canvas的尺寸和图片一样
        height = video.height
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(video, 0, 0, width, height) //绘制canvas
      dataURL = canvas.toDataURL('image/jpeg') //转换为base64
      resolve(dataURL)
    })
  })
}
// 将视频转成base64进制的
export function changeVideoBase64(file, callback = () => {}) {
  var reader = new FileReader()
  var rs = reader.readAsDataURL(file)
  reader.onload = (e) => {
    var videoSrc = e.target.result
    callback(videoSrc)
  }
}

export function getSourceWidthHeight(url, callback = () => {}) {
  let img = new Image()
  img.src = url
  return new Promise((resolve) => {
    img.onload = function () {
      resolve(img)
    }
  })
}

export function getSelected() {
  if (window.getSelection) {
    return window.getSelection().toString()
  } else if (document.getSelection) {
    return document.getSelection().toString()
  } else {
    var selection = document.selection && document.selection.createRange()
    if (selection.text) {
      return selection.text.toString()
    }
    return ''
  }
}

// 函数防抖
export const debounce = (fn, delay = 300) => {
  let timer = null
  return (...args) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

// 处理菜单接口字段
export const dealInterfaceMenu = (menu,result={})=>{
  result.path = menu.auth_key.trim()
  result.redirect = menu.auth_rules.trim()
  result.icon = menu.auth_icon.trim()
  result.auth_name = menu.auth_name.trim()
  if(menu.childs && menu.childs.length){
    result.children = []
    menu.childs.map(son=>{
      let son_obj =  dealInterfaceMenu(son)
      result.children.push(son_obj)
    })
  }
  return result
}

// 集中处理价格逻辑
export const concentrateDealPrice = (car_info = {})=>{
	let is_pre  =  false 
	let price_data = {
		original_price:{label:'批发价',price:dealPrice(car_info.original_price)},
		price:{label:'零售价',price:dealPrice(car_info.price)},
		peer_price:{label:'同行租',price:dealPrice(car_info.peer_price)},
		rent_price:{label:'租赁价',price:dealPrice(car_info.rent_price)}
	}
	// 鉴别权限 获取车辆状态
	if(car_info.is_pre || (car_info.is_pre == 0 && car_info.status == 'ONLINESALL')) is_pre = true
	if(is_pre){
		price_data.price.label = '预售价'
		price_data.price.price = dealPrice(car_info.pre_price)
	}
	if(car_info.is_mianyi){
		price_data.peer_price.label = '租赁价'
		price_data.peer_price.price = '面议'
		price_data.rent_price.price = '面议'
	}
	return price_data
}

export const dealTonnageName = (option_name)=>{
	// 检查数据有效性
 if (!option_name) return 0
 const optionName = option_name.toString()
 // 去除"kg"字符串
 const numberStr = optionName.replace(/kg/gi, '').trim()
 // 转换为数字
 const numberValue = parseFloat(numberStr)
 // 检查是否为有效数字
 if (isNaN(numberValue)) return 0
 // 除以1000并保留一位小数
 const result = (numberValue / 1000).toFixed(1)
 return result + '吨' // 返回数字类型，而不是字符串
}

export const dealRiseName = (option_name)=>{
	// 检查数据有效性
 if (!option_name) return 0
 const optionName = option_name.toString()
 // 去除"kg"字符串
 const numberStr = optionName.replace(/mm/gi, '').trim()
 // 转换为数字
 const numberValue = parseFloat(numberStr)
 // 检查是否为有效数字
 if (isNaN(numberValue)) return 0
 // 除以1000并保留一位小数
 const result = (numberValue / 1000).toFixed(1)
 return result + '米' // 返回数字类型，而不是字符串
}

// 处理价格计算 精确到百位 自动进一 price-元
export const dealPriceCalc = (price)=>{
  let p = parseFloat(price)
  if(!p) return 0
  return Math.ceil(p / 100) * 100
}